<template>
    <div class="schedule-main-div">


      <!-- TITLE @xs STATIC -->
      <!--
      <div class="uk-grid uk-grid-small uk-visible@xs uk-hidden@s schedule-bg-hover gridcenter1200" style="padding: 5px 0;" hidden>
        <div class="uk-width-1-3" style="padding: 5px;">
          <div class="pbs-schedule-grid-time-xs">33:00&nbsp;am</div>
        </div>
        <div class="uk-width-2-3" style="padding: 5px;">
          <div class="x-button"></div>
          <div class="button-schedule button-watch-now">watch now</div>
        </div>
        <div class="uk-width-1-1" style="padding: 10px;">
          <div class="pbs-schedule-grid-title2" style="margin-bottom: 10px;">Program title xs xs xs mobile</div>
          <div class="pbs-schedule-grid-subtitle2">Subtitle subtitle g j xs xs xs mobile</div>
        </div>
      </div>
        < ! -- END TITLE @xs STATIC -- >
      <div class="schedule-row" hidden>
        <div class="uk-grid uk-grid-small uk-visible@s" style="max-width: 1200px; margin: auto; padding: 5px 0;">
          <div class="uk-width-1-6@s" style="background: ; padding: 5px;">
            <div class="pbs-schedule-grid-time2">22:00&nbsp;am</div>
          </div>
          <div class="uk-width-2-3@s" style="background: ; padding: 5px 10px;">
            <div class="pbs-schedule-grid-title2" style="margin-bottom: 10px;">Program title LLL large screenj j</div>
            <div class="pbs-schedule-grid-subtitle2">Subtitle program subtitle L L L L </div>
          </div>
          < !--this div with buttons is HIDDEN for @xs -- >
          <div class="uk-width-1-6@s uk-hidden@xs uk-visible@s" style="background: ; padding: 5px;">
            <div style="float: right; width: 100%;">
              <div class="x-button"></div>
              <div class="pbs-play-button uk-visible@s uk-hidden@m">< !--PLAY-- ></div>
              <div class="button-schedule button-watch-now uk-visible@xs uk-hidden@s">watch now</div>
              <div class="button-schedule button-watch-now uk-hidden@xs uk-visible@m">watch now</div>
            </div>
          </div>
        </div>

        < !--CONTENT-- >
        <div class="uk-grid uk-grid-small" style="max-width: 1200px; margin: auto; padding: 0 0 5px 0;" hidden>
          <div class="uk-width-1-6@m" style="background: ; padding: 5px;">
            <div class="button-schedule button-float-xs button-float-m-margin">all airdates</div>
            <div class="button-schedule button-float-xs">remind me</div>
          </div>
          <div class="uk-width-1-2@m" style="background: ; padding: 5px 10px;">
            <div class="pbs-schedule-synopsis">Dustin Lynch: The Country singer/songwriter's February 2020 concert at Analog at the Hutton Hotel is an exuberant celebration of what was already a big year for him with the release of his concept album Tullahoma one month prior. Lynch's heavily autobiographical set list includes the title track inspired by his childhood</div>
            <div style="font-size: 18px; font-family: Avenir-medium; margin-top: 20px;">53 minutes &nbsp; <span style="font-family: Avenir-light; color: #00000044;">&vert;</span> &nbsp; episode 1</div>
          </div>
          <div class="uk-width-1-3@m" style="background: ; padding: 5px;">
            <div style="background: #ddd; width: 100%; height: 200px; padding: 40px; text-align: center;">video thumbnail</div>
          </div>
        </div>
      </div>
      -->

      <!--TITLE @xs-->
      <div v-for="air_data in schedule_data"
           v-bind:key="`mobile-${air_data.fulldate}`"
           :id="`${(air_data.now_playing)?'schedule-now-playing-mobile':''}`"
           :class="`${(selected_air_data === air_data && Object.keys(selected_air_data).length > 0)|| (first_click && air_data.now_playing) ? 'schedule-open':''} uk-grid uk-grid-small uk-visible@xs uk-hidden@s schedule-bg-hover gridcenter1200 ${(air_data.now_playing)?'schedule-now-playing-mobile':''}`"
           style="padding: 5px 0;border-top: 1px solid rgba(0,0,0,.5);">

        <div @click="set_air_data(air_data)" class="uk-width-1-3" style="padding: 5px;">
          <div class="pbs-schedule-grid-time2" style="font-size: 16px; text-align: left;">{{air_data.show_time}}</div>
        </div>
        <div class="uk-width-2-3" style="padding: 5px;">

          <div v-if="selected_air_data === air_data || (first_click && air_data.now_playing)" @click="set_air_data({})" class="minus-button"></div>
          <a v-else @click="set_air_data(air_data)" class="x-button"></a>

          <div class="uk-width-2-3" style="padding: 5px;" hidden>
            <div class="x-button"></div>
            <div class="button-schedule button-watch-now">watch now</div>
          </div>
          <!-- Mobile - PASSPORT or PUBLIC -->
          <a class="button-schedule button-watch-now" v-if="air_data.program_details.display_option == 9
                                && air_data.program_details.media_manager_data.passport != null
                                && air_data.program_details.media_manager_data.passport != undefined" target="_blank"
             :href="`https://video.pbs12.org/video/${air_data.program_details.media_manager_data.passport.asset_slug}/`">watch now</a>
          <a class="button-schedule button-watch-now" v-else-if="air_data.program_details.display_option == 9
                                && air_data.program_details.media_manager_data.public != null
                                && air_data.program_details.media_manager_data.public != undefined" target="_blank"
             :href="`https://video.pbs12.org/video/${air_data.program_details.media_manager_data.public.asset_slug}/`">watch now</a>

        </div>
        <div @click="set_air_data(air_data)" class="uk-width-1-1" style="padding:10px;">
          <div class="pbs-schedule-grid-title2" style="margin-bottom: 10px;">{{air_data.series_title}}</div>
          <div class="pbs-schedule-grid-subtitle2" v-if="air_data.episode_title.length > 0 && air_data.series_title !== air_data.episode_title">{{air_data.episode_title}}</div>
          <div class="pbs-schedule-grid-subtitle2" v-else>&nbsp;</div>
        </div>
        <!--CONTENT-->
        <ProgramDetails v-if="(selected_air_data === air_data && Object.keys(selected_air_data).length > 0) || (first_click && air_data.now_playing)"
                        v-bind:air_data="air_data"
                        v-bind:suffix="'mobile'"
                        v-bind:open_passport="(air_data.program_details.display_option == 9
                                && air_data.program_details.media_manager_data.passport != null
                                && air_data.program_details.media_manager_data.passport != undefined)"/>
      </div>

      <!--TITLE-->
      <div v-for="air_data in schedule_data"
           v-bind:key="air_data.fulldate"
           v-bind:suffix="''"
           style="border-bottom: 1px solid #00000033;"
           :class="`${(selected_air_data === air_data && Object.keys(selected_air_data).length > 0) || (first_click && air_data.now_playing) ? 'schedule-open':''} schedule-row uk-visible@s ${(air_data.now_playing)?'schedule-now-playing':''}`">

        <div class="uk-grid uk-grid-small uk-visible@s" style="max-width: 1140px; margin: auto; padding: 5px 0;">
                      <!-- :style="(selected_air_data.fulldate != undefined && selected_air_data.fulldate == air_data.fulldate)
                                ? 'background-color: #f8f5ec;max-width: 1200px; margin: auto;'
                                :'max-width: 1200px; margin: auto;'"-->

          <div @click="set_air_data(air_data)" class="uk-width-1-6@m" style="padding: 5px;">
            <div class="pbs-schedule-grid-time2">{{air_data.show_time}}</div>
          </div>

          <div @click="set_air_data(air_data)" class="uk-width-5-6@s uk-width-2-3@m" style="padding: 5px 10px;">
            <div class="pbs-schedule-grid-title2" style="margin-bottom: 10px;">{{air_data.series_title}}</div>
            <div class="pbs-schedule-grid-subtitle2" v-if="air_data.episode_title.length > 0 && air_data.series_title !== air_data.episode_title">{{air_data.episode_title}}</div>
            <div class="pbs-schedule-grid-subtitle2" style="opacity: 0" v-else>_</div>
          </div>

          <div class="uk-width-1-6@s uk-hidden@xs uk-visible@s" style="padding: 5px">
            <div style="float: right; width: 100%;">

              <div v-if="selected_air_data === air_data || (first_click && air_data.now_playing)" @click="set_air_data({})" class="minus-button" :id="`${(air_data.now_playing)?'schedule-now-playing':''}`"></div>
              <a v-else @click="set_air_data(air_data)" class="x-button" :id="`${(air_data.now_playing)?'schedule-now-playing':''}`"></a>

              <!-- Tablet - PASSPORT or PUBLIC -->
              <a v-if="air_data.program_details.display_option == 9
                                && air_data.program_details.media_manager_data.passport != null
                                && air_data.program_details.media_manager_data.passport != undefined" target="_blank"
                   :href="`https://video.pbs12.org/video/${air_data.program_details.media_manager_data.passport.asset_slug}/`"
                   class="pbs-play-button uk-visible@s uk-hidden@m"></a>
              <a v-else-if="air_data.program_details.display_option == 9
                                && air_data.program_details.media_manager_data.public != null
                                && air_data.program_details.media_manager_data.public != undefined" target="_blank"
                   :href="`https://video.pbs12.org/video/${air_data.program_details.media_manager_data.public.asset_slug}/`"
                   class="pbs-play-button uk-visible@s uk-hidden@m"></a>


              <!-- Regular width - PASSPORT or PUBLIC -->
                <a class="button-schedule button-watch-now uk-hidden@xs uk-visible@m" v-if="air_data.program_details.display_option == 9
                                  && air_data.program_details.media_manager_data.passport != null
                                  && air_data.program_details.media_manager_data.passport != undefined" target="_blank"
                     :href="`https://video.pbs12.org/video/${air_data.program_details.media_manager_data.passport.asset_slug}/`">watch now</a>
                <a class="button-schedule button-watch-now uk-hidden@xs uk-visible@m" v-else-if="air_data.program_details.display_option == 9
                                  && air_data.program_details.media_manager_data.public != null
                                  && air_data.program_details.media_manager_data.public != undefined" target="_blank"
                     :href="`https://video.pbs12.org/video/${air_data.program_details.media_manager_data.public.asset_slug}/`">watch now</a>
            </div>
          </div>
        </div>
        <!--CONTENT-->
        <ProgramDetails v-if="(selected_air_data === air_data && Object.keys(selected_air_data).length > 0) || (first_click && air_data.now_playing)"
                        v-bind:air_data="air_data" v-bind:open_passport="(air_data.program_details.display_option == 9
                                && air_data.program_details.media_manager_data.passport != null
                                && air_data.program_details.media_manager_data.passport != undefined)"/>
      </div>

    </div>
</template>

<script>
import ProgramDetails from "./ProgramDetails";

export default {
    components: {ProgramDetails},
    props:['schedule_data'],
    name: "SingleChannelSchedule",
    mounted() {
      // setTimeout(() =>{
      //   if($("#schedule-now-playing").html() != undefined) {
      //     $('html, body').animate({scrollTop: $("#schedule-now-playing").offset().top - 200}, 1000)
      //     $("#schedule-now-playing").click()
      //   }
      // }, 2000)
    },
    data(){
      return {
          base_url: 'https://www.pbs12.org/',
          selected_air_data: {},
          first_click:true
      }
    },
    methods:{
      set_air_data(data){
        this.selected_air_data = data
        this.first_click = false
      }
    }
}
</script>

<style scoped>
    .pbs-schedule-grid-time {
        color: black !important;
    }
    .pbs-schedule-grid-details-content {
        min-width: 290px;
        padding-left: 55px;
        padding-rigth: 20px;
    }
    .pbs-schedule-grid-details {
        background-color: #f8f5ec;
    }
    .uk-open{
        background-color: #f8f5ec;
    }

    li {
      border-bottom: 1px solid #c3c3c3;
    }
    /*li:hover{
      background-color: #f8f5ec;
    }*/
    .uk-accordion-title:hover{
      /*background: #fff9c7;*/
      background-color: #f8f5ec;
    }
    .uk-accordion-title{
      /*max-width: 1200px;*/
      margin-left: auto;
      margin-right: auto;
    }
    .schedule-li-content:hover{
      background-color: #f8f5ec;
    }
    /*.uk-accordion-title:hover{*/
    /*  background: #fff9c7;*/
    /*}*/
    .uk-tab>*:hover{
      background-color: transparent;
    }

</style>